import React, { useState } from 'react';
import classNames from 'classnames';
import { getVipTag, getIncomeSource, isAppStorePay } from '@/utils/vip';
import AvatarDefault from '@/assets/image/vip/avatar-default.png';
import Svip from '@/assets/image/vip/svip.png';
import Vip from '@/assets/image/vip/vip.png';
import NoVip from '@/assets/image/vip/no-vip.png';
import TeamVip from '@/assets/image/team/team-vip.png';
import TeamNoVip from '@/assets/image/team/team-no-vip.png';
import LoginMethods from '../login-methods';
import { getUrlParam } from '@/utils';
import { SubscribeType, isTeamSubscription, subscribeType } from '@/constants';
import CutoutCountInfoModal from '../cutout-count-info';
import { TabType } from '@/constants/subscription';
import { useAtom } from 'jotai';
import {
  batchSizeAtom,
  curTabAtom,
  cutoutInfoAtom,
  hasFetchUserInfoAtom,
  meidouTotalAtom,
  teamInfoAtom,
  userInfoAtom,
  vipInfoAtom,
  visibleMeidouInfoModalAtom,
} from '@/store';
import { track } from '@/utils/common';
import { handleJumpLogin } from '@/utils/user';
import ArrowImg from '@/assets/image/new/right-arrow.png';

import styles from './index.module.css';

const Userinfo = () => {
  const type = getUrlParam('type'); // PC端订阅URL里定义的参数，区分是会员还是批处理
  const hideSwitchBtn = !!+(getUrlParam('hideSwitchBtn') || '0'); // 单购场景下，是否暴露会员和张数的切换入口

  const [visible, setVisible] = useState<boolean>(false);

  const [curTab, setCurTab] = useAtom(curTabAtom);
  const [hasFetchUserInfo] = useAtom(hasFetchUserInfoAtom);
  const [userInfo] = useAtom(userInfoAtom);
  const [teamInfo] = useAtom(teamInfoAtom);
  const [batchSize] = useAtom(batchSizeAtom);
  const [cutoutInfo] = useAtom(cutoutInfoAtom);
  const [vipInfo] = useAtom(vipInfoAtom);
  const [meidouTotal] = useAtom(meidouTotalAtom);
  const [, setVisibleMeidouInfoModal] = useAtom(visibleMeidouInfoModalAtom);

  const handleJumpAccount = () => {
    let prefix = process.env.REACT_APP_ENV;

    if (process.env.REACT_APP_ENV === 'release') {
      prefix = '';
    }

    const url = `https://${prefix}account.meitu.com/#!/account`;

    if (getIncomeSource() === 'MTXX-WEB') {
      window.open(url);
    } else {
      // native.openBrowser(url);
    }
  };

  const handleViewDetail = () => {
    setVisible(true);

    track({
      event_id: 'vip_page_click',
      event_name: '会员落地页点击',
      params: {
        class: 'look_detail',
      },
    });
  };

  const handleMeidouInfoClick = () => {
    setVisibleMeidouInfoModal(true);
    track({
      event_id: 'vip_page_click',
      event_name: '会员落地页点击',
      params: {
        class: 'surplus',
      },
    });
  };

  const handleTabChange = () => {
    let value = TabType.SUB;
    if (subscribeType === SubscribeType.MEIDOU) {
      // 美豆切换场景
      value = curTab === TabType.MEIDOU ? TabType.SUB : TabType.MEIDOU;
    } else if (subscribeType === SubscribeType.CONSUMABLE) {
      // 抠图切换场景
      value = curTab === TabType.CUTOUT ? TabType.SUB : TabType.CUTOUT;
    }

    track({
      event_id: 'vip_page_click',
      event_name: '会员落地页点击',
      params: {
        class:
          value === TabType.CUTOUT ? 'buynum' : value === TabType.MEIDOU ? 'buymeidou' : 'buyvip',
      },
    });

    setCurTab(value);
  };

  const renderDesc = () => {
    if (!userInfo?.id) {
      return isAppStorePay()
        ? '请登录后购买会员，以确保您的会员作品不会丢失'
        : `请登录后购买${type === 'svip' ? '' : '会员'}`;
    }

    if (type === 'svip') {
      // batchSize
      return `批处理剩余张数：${batchSize}`;
    }

    if (subscribeType === SubscribeType.CONSUMABLE || subscribeType === SubscribeType.MEIDOU) {
      // 抠图剩余张数
      const leftNumber = cutoutInfo?.left || 0;
      return (
        <>
          <div style={{ cursor: 'initial' }}>
            {subscribeType === SubscribeType.CONSUMABLE ? '抠图张数：' : '美豆余额：'}
            <span
              className={styles.number}
              onClick={() => {
                if (subscribeType === SubscribeType.CONSUMABLE && leftNumber) {
                  handleViewDetail();
                } else if (subscribeType === SubscribeType.MEIDOU) {
                  handleMeidouInfoClick();
                }
              }}
              style={{
                textDecoration:
                  (subscribeType === SubscribeType.CONSUMABLE && leftNumber) ||
                  subscribeType === SubscribeType.MEIDOU
                    ? 'underline'
                    : '',
              }}
            >
              {subscribeType === SubscribeType.CONSUMABLE ? leftNumber : meidouTotal}
            </span>
          </div>
          {!hideSwitchBtn ? (
            <div className={styles.viewDetail} onClick={handleTabChange}>
              {[TabType.CUTOUT, TabType.MEIDOU].includes(curTab as TabType)
                ? '购买会员'
                : subscribeType === SubscribeType.CONSUMABLE
                ? '购买张数'
                : '购买美豆'}
              <img className={styles.icon} src={ArrowImg} />
            </div>
          ) : null}
        </>
      );
    }

    return '';
  };

  const renderMethods = () => {
    if (isTeamSubscription) {
      const phone = teamInfo?.super_admin?.phone;
      return phone ? <span className={styles.loginMethods}>（已绑定账号： {phone}）</span> : null;
    }

    if (userInfo?.login_methods?.length) {
      return (
        <span className={styles.loginMethods}>
          （已绑定账号：
          <LoginMethods userInfo={userInfo} />）
        </span>
      );
    }
  };

  const showVipTag =
    hasFetchUserInfo && userInfo?.id && !getVipTag(vipInfo).hasNoBuy && type !== 'svip'; // 非批处理

  const vipIcon = isTeamSubscription ? TeamVip : Svip;
  const noVipIcon = isTeamSubscription ? TeamNoVip : NoVip;
  const avatar = isTeamSubscription ? teamInfo?.logo : userInfo?.avatar;
  const name = isTeamSubscription ? teamInfo?.name : userInfo?.screen_name;

  return (
    <>
      <div className={styles.module}>
        <div
          className={classNames(
            styles.avatarBox,
            getVipTag(vipInfo).svip && styles.avatarSvip,
            getVipTag(vipInfo).vip && styles.avatarVip,
            !getVipTag(vipInfo).svip && !getVipTag(vipInfo).vip && styles.avatarNoVip
          )}
        >
          {avatar ? (
            <img
              className={styles.avatar}
              src={avatar || AvatarDefault}
              alt=""
              onClick={handleJumpAccount}
            />
          ) : (
            <div
              className={classNames(styles.defaultAvatar, !hasFetchUserInfo && styles.skeleton)}
              style={{ cursor: 'pointer' }}
              onClick={handleJumpLogin}
            ></div>
          )}
          {showVipTag ? (
            <img
              className={styles.vipIcon}
              src={getVipTag(vipInfo).svip ? vipIcon : getVipTag(vipInfo).vip ? Vip : noVipIcon}
              alt=""
            />
          ) : null}
        </div>
        <div className={styles.right}>
          {userInfo?.id ? (
            <div className={styles.username} onClick={handleJumpAccount}>
              {name}
              {renderMethods()}
            </div>
          ) : (
            <div
              className={classNames(styles.username, !hasFetchUserInfo && styles.skeleton)}
              onClick={handleJumpLogin}
            >
              {isAppStorePay() ? '点击登录' : '点击登录（登录即注册）'}
            </div>
          )}

          {hasFetchUserInfo && renderDesc() ? (
            <div className={styles.bottom}>{renderDesc()}</div>
          ) : null}
        </div>
      </div>

      <CutoutCountInfoModal visible={visible} onClose={() => setVisible(false)} />
    </>
  );
};

export default React.memo(Userinfo);
